// extracted by mini-css-extract-plugin
export default {"img":"Image_img__MfDJC","wrapper":"Image_wrapper__lvs-q","imgFull":"Image_imgFull__MiqnJ","dialog":"Image_dialog__Kh7MD"};